export default __webpack_public_path__ + "static/media/ico-accessibility.c86815b3.svg";